import React from 'react'

import {
  CandleChartFilledIcon,
  Crown2Icon,
  DelugeIcon,
  NftIcon,
} from '@root/shared/ui-kit'

import { NFT, Premium, Pump, Terminal } from '../../model/platform-tokens'
import { PLATFORM_COLORS } from '../platform-colors'

import type { IconProps } from '@blade/ui-kit'

const createPlatformIcon =
  (
    svgContent: React.ReactNode,
    gradientFrom: string,
    gradientTo: string,
    viewBox = '0 0 24 24',
  ) =>
  ({ size = 24, width, height, ref, ...props }: IconProps) => {
    const resolvedSize = width || height ? undefined : size
    const gradientId = React.useId()
    const maskId = React.useId()
    const hasGradient = gradientFrom && gradientTo

    return (
      <svg
        fill="none"
        role="graphics-symbol"
        width={width || resolvedSize}
        height={height || resolvedSize}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        {hasGradient ? (
          <>
            <defs>
              <linearGradient
                id={gradientId}
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor={gradientFrom} />
                <stop offset="100%" stopColor={gradientTo} />
              </linearGradient>
              <mask id={maskId}>{svgContent}</mask>
            </defs>
            <rect
              width="100%"
              height="100%"
              fill={`url(#${gradientId})`}
              mask={`url(#${maskId})`}
            />
          </>
        ) : (
          svgContent
        )}
      </svg>
    )
  }

export const TerminalPlatformFilledIcon = createPlatformIcon(
  <CandleChartFilledIcon />,
  PLATFORM_COLORS[Terminal].square.outlinedGradient[0],
  PLATFORM_COLORS[Terminal].square.outlinedGradient[1],
  '0 0 24 24',
)

export const PremiumPlatformFilledIcon = createPlatformIcon(
  <Crown2Icon />,
  PLATFORM_COLORS[Premium].square.outlinedGradient[0],
  PLATFORM_COLORS[Premium].square.outlinedGradient[1],
  '0 0 24 24',
)

export const NftPlatformFilledIcon = createPlatformIcon(
  <NftIcon />,
  PLATFORM_COLORS[NFT].square.outlinedGradient[0],
  PLATFORM_COLORS[NFT].square.outlinedGradient[1],
  '0 0 24 24',
)

export const PumpPlatformFilledIcon = createPlatformIcon(
  <DelugeIcon />,
  PLATFORM_COLORS[Pump].square.outlinedGradient[0],
  PLATFORM_COLORS[Pump].square.outlinedGradient[1],
  '0 0 24 24',
)
